<template>
  <div id="app" :style="{height:tableHeight,width:tableWidth}">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <el-dialog title="正在下载，请等待" :visible="progressShow" :close-on-click-modal="false"
               :close-on-press-excape="false" width="20%">
      <div style="text-align: center;">
        <el-row v-if="percentage === 0">文件生成中...</el-row>
        <el-progress v-else :percentage="percentage" type="circle"></el-progress>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  data() {
    return {
      tableHeight: "",
      tableWidth: "",
      progressShow: false,
      percentage: 0,
    }
  },
  provide(){
    return{
      exportPercentage: this.exportPercentage,
    }
  },
  methods: {
    exportPercentage(name, url, params) {
      //进度置0
      this.percentage = 0;

      let {insuranceTypeList, ...param} = params;

      this.progressShow = true;
      this.$axios({
        url: url,
        method: "get",
        responseType: "blob",
        params: param,
        onDownloadProgress: (progressEvent) => {
          let progressBar = Math.round(ProgressEvent.loaded / progressEvent.total * 100);
          this.percentage = progressBar ? progressBar : 0;

          // if(ProgressEvent.loaded === 0){
          //   this.percentage = 99;
          //   this.$message.success("正在生成文件中。");
          // }else{
          //   this.percentage = progressBar;
          //   this.$message("正在下载，请稍等。");
          // }
        }
      }).then(res => {
        if (res.status != 200) {
          this.$message.error("文件下载失败，请稍后再试！");
        }

        let blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        if (window.navigator && window.navigator.meSaveOrOpenBlob) {
          window.navigator.meSaveOrOpenBlob(blob, "文件名称.xlsx");
        } else {
          const link = document.createElement('a');
          const body = document.querySelector('body');
          link.href = window.URL.createObjectURL(blob);

          let timestamp = Date.parse(new Date()); // 1604297892000
          link.download = name + '-' + timestamp;//文件名称

          link.style.display = "none";
          body.appendChild(link);
          link.click();
          body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

        }

        this.percentage = 100;
        this.progressShow = false;
      }).catch(error=>{
        this.$message.error("文件下载失败，请联系管理员！");
        this.progressShow = false;
      });
    },
  },
  mounted() {
    this.tableHeight = (window.innerHeight) + 'px';
    this.tableWidth = (window.innerWidth) + 'px';
    let $this = this;

    window.onresize = () => {
      return (() => {
        $this.tableHeight = (window.innerHeight) + 'px';
        $this.tableWidth = (window.innerWidth) + 'px';
      })()
    }
  }
}
</script>

<style lang="scss">
.fontBig {
  font-size: 16px !important;
}

.el-table__header,.el-table__body,.el-table__footer {
  width: 100%;
  table-layout: fixed !important;
}

.el-textarea__inner {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.speClass .el-form-item__content {
  margin-left: 14px !important;
}

.speClass__s .el-form-item__content {
  margin-left: 60px !important;
}

html, body, #app {
}

body {
  margin: 0px;
  padding: 0px;
  /*background: url(assets/bg1.jpg) center !important;
    background-size: cover;*/
  // background: #1F2D3D;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif !important;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

.el-table .el-table__body .cell {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 22px;
  line-height: 25px !important;
  text-align: center;
}

#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  //width: window.screen.width;
}

.el-submenu [class^=fa] {
  vertical-align: baseline;
  margin-right: 10px;
}

.el-menu-item [class^=fa] {
  vertical-align: baseline;
  margin-right: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

body .el-scrollbar-self > .el-scrollbar__wrap {
  overflow-x: auto;
}

body.el-loading-parent--relative {
  position: static !important;
}

body.el-loading-parent--relative {
  position: static !important;
}

.el-loading-mask.is-fullscreen {
  z-index: 5000 !important;
}

/***** 搜索框 *****/
.tool-bar {
  border-radius: 3px;
  margin-top: -1px;
  background: #FFFFFF;
  padding: 15px 15px 15px 15px;
  text-align: left;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);

  .el-input {
    width: 200px;
  }
}

/*dialog*/
.el-dialog {
  .el-dialog__body {
    padding: 15px 20px 30px;
  }
}

/*.el-pagination*/
.el-pagination {
  margin-top: 10px;
}

* .is-disabled * {
  color: #000000 !important;
}

.el-drawer__body {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// App.vue?848535c0